'use strict';

import MyApi from '@api/my';

import { LoggerBus } from '@app/utils/logger-bus';
const loggerFormat = '[app::services::my::training]';

const getProgram = async () => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await MyApi.program();
    return response.data;
}

const getSchedule = async () => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await MyApi.schedule();
    return response.data;
}

const getRecords = async (date, version) => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await MyApi.records({date, version});
    return response.data;
}

const getRecordsDownload = async (data) => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await MyApi.recordsDownload(data);
    return response.data;
}

const getRecordScore = async ({ registrationId, scoreId }) => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await MyApi.recordScore(registrationId, scoreId);
    return response.data;
}

const getCertificate = async (hash) => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await MyApi.certificate(hash);
    return response.data;
}

const getCertificateDownload = async (hash) => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await MyApi.certificateDownload(hash);
    return response.data;
}

const getTraining = async (hash) => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await MyApi.training(hash);
    return response.data;
}

export default {
    getProgram,
    getSchedule,
    getRecords,
    getRecordsDownload,
    getRecordScore,
    getCertificate,
    getCertificateDownload,
    getTraining
};
